<div class="field-analysis-container">
  <div class="left-column">
    <div class="ndvi-chart-container">
      <app-ndvi-chart [fieldId]="fieldId"></app-ndvi-chart>
    </div>
    <div class="crop-spray-chart-container">
      <app-crop-spray-analysis [fieldId]="fieldId"></app-crop-spray-analysis>
    </div>
    <div class="crop-bio-chart-container">
      <app-crop-bio [fieldId]="fieldId"></app-crop-bio>
    </div>
    <div class="micronutrients-chart-container">
      <app-micronutrients [fieldId]="fieldId"></app-micronutrients>
    </div>
  </div>
  <div class="right-column">
    <div class="info-card">
      <p><strong class="field-analysis-header">Field Details - {{ fieldName }}</strong></p>
      <p><strong>Crop: </strong><span *ngIf="!fieldInfoLoading">{{ crop }}</span><span *ngIf="fieldInfoLoading" class="skeleton-text"></span></p>
      <p><strong>Cultivar: </strong><span *ngIf="!fieldInfoLoading">{{ cultivar }}</span><span *ngIf="fieldInfoLoading" class="skeleton-text"></span></p>
      <p><strong>Season:</strong> {{ seasonYear }}</p>
      <app-field-map [fieldId]="fieldId" [farmId]="farmId"></app-field-map>
      <button class="map-analysis-btn" (click)="navigateToFieldAnalysis()">
        Map Analysis
        <mat-icon>visibility</mat-icon>
      </button>
    </div>
    <div class="irrigation-chart-container-bottom">
      <app-irrigation-chart [fieldId]="fieldId"></app-irrigation-chart>
    </div>
    <div class="macronutrients-chart-container">
      <app-macronutrients [fieldId]="fieldId"></app-macronutrients>
    </div>
    <div class="gibberellin-chart-container">
      <app-gibberellin [fieldId]="fieldId"></app-gibberellin>
    </div>
  </div>
</div>
